// extracted by mini-css-extract-plugin
export default {"products":"ov-z","card":"pv-z","oosMessaging":"qv-z"};